import React from 'react';

export const childComponentGenerator = (parentComponent, defaultTag = 'div', defaultClassName, name, scn) => {
  const GeneratedComponent = ({ tag = defaultTag, className, children }) =>
    React.createElement(tag, { className: `${scn(defaultClassName)} ${className || ''}` }, children);

  parentComponent[name] = GeneratedComponent;
  return GeneratedComponent;
};